import LogsRoute from 'cio/pods/logs/route';

export default class ActivityRoute extends LogsRoute {
  crumb() {
    return {
      name: 'Activity Logs',
      path: 'person.activity',
    };
  }

  model() {
    return this.modelFor('person');
  }
}
